import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListChallengeIssuesRequest } from './list-challenge-issues-request';
import type { IListChallengeIssuesResponse } from './list-challenge-issues-response';
import { listChallengeIssuesResponseSchema } from './list-challenge-issues-response';

export async function listChallengeIssuesApi({
  status,
  reporterUserId,
  limit,
  offset,
}: IListChallengeIssuesRequest = {}): Promise<IValidatedResponse<IListChallengeIssuesResponse>> {
  return getRequest<IListChallengeIssuesResponse>({
    path: '/sys/challenge-issues/v1',
    schema: listChallengeIssuesResponseSchema,
    options: {
      params: {
        status,
        reporterUserId,
        limit,
        offset,
      },
    },
  });
}
